import PropTypes from 'prop-types';
import classnames from 'classnames';
import uniqid from 'uniqid';
import { connect } from 'react-redux';
import { handleResultHeaderSelect } from '../../redux/actions/resultsActions';
import { resultTypes } from '../../appSettings';
import SelectedFiltersPanel from '../resultList/selectedFiltersPanel/selectedFiltersPanel';
import './headerResult.scss';

const HeaderResult = ({
  onHandleResultHeaderSelect,
  results,
  labels,
}) => {

  const getResultTypeCount = (resultType) => {
    // For each of the types (hotels, destinations etc)
    if (Object.keys(results.resultsCount).includes(resultType)) {
      return results.resultsCount[resultType] || '-';
    }
    return results.resultsCount?.total || '-';
  }

  return (
    <>
      <div className="vf-header-styles">
        <h1>{labels.vacationFinderResultHeader}</h1>
      </div>

      <SelectedFiltersPanel />

      <nav className="vf-header-result__tab-nav">
        {Object.keys(resultTypes).map((resultTypeKey) => {
          const resultType = resultTypes[resultTypeKey];
          if (resultType === resultTypes.ARTICLES) {
            return null;
          }  
          const resultTypeCount = getResultTypeCount(resultType);
          const resultTypeHeader = labels[`header_${resultType}`]

          const tabNavButtonClasses = classnames({
            'vf-header-result__tab-nav-button': true,
            'vf-header-result__tab-nav-button--selected': results.selectedResultHeader === resultType,
          });
          return (
            <button
              className={tabNavButtonClasses}
              key={uniqid('tab-nav-button-')}
              onClick={() => onHandleResultHeaderSelect(resultType)}
              type="button"
            >
              {`${resultTypeHeader} (${resultTypeCount || '-'})`}
            </button>
          );
        })}
      </nav>
    </>
  )
}

HeaderResult.propTypes = {
  labels: PropTypes.shape({
    vacationFinderResultHeader: PropTypes.string.isRequired,
    header_all: PropTypes.string.isRequired,
    header_hotels: PropTypes.string.isRequired,
    header_destinations: PropTypes.string.isRequired,
    header_excursions: PropTypes.string.isRequired,
    header_grouptrips: PropTypes.string.isRequired,
  }).isRequired,
  results: PropTypes.shape({
    selectedResultHeader: PropTypes.string.isRequired,
    resultsCount: PropTypes.shape({
      total: PropTypes.number,
      [resultTypes.HOTELS]: PropTypes.number,
      [resultTypes.DESTINATIONS]: PropTypes.number,
      [resultTypes.EXCURSIONS]: PropTypes.number,
      [resultTypes.GROUP_TRIPS]: PropTypes.number,
      [resultTypes.ARTICLES]: PropTypes.number,
    }).isRequired,
  }).isRequired,
  onHandleResultHeaderSelect: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => {
  return {
    onHandleResultHeaderSelect: (resultType) => {
      dispatch(handleResultHeaderSelect(resultType));
    },
  };
};

const mapStateToProps = ({ attributeCollection, siteSettings, results }) => {
  const labels = {
    vacationFinderResultHeader: attributeCollection.vacationFinderResultHeader,
    header_all: attributeCollection.vacationFinderResultLabels.header_all,
    header_hotels: attributeCollection.vacationFinderResultLabels.header_hotels,
    header_destinations: attributeCollection.vacationFinderResultLabels.header_destinations,
    header_excursions: attributeCollection.vacationFinderResultLabels.header_excursions,
    header_grouptrips: attributeCollection.vacationFinderResultLabels.header_grouptrips,
  }
  return {
    selectedSecondaryClassifications: siteSettings.filters.selectedSecondaryClassifications,
    results,
    labels,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderResult);